import { useState } from "react";
import { HiEnvelope, HiMapPin, HiPhone } from "react-icons/hi2";
import { FaWhatsapp } from "react-icons/fa6";
import contactHeroBg from "../assets/contacthero.png";
import { openContactInquiryWhatsApp } from "../utils/whatsapp";

const contactItems = [
  {
    title: "Phone",
    value: "+91 9867480688",
    note: "Call us for admissions and general enquiries",
    icon: HiPhone,
  },
  {
    title: "WhatsApp",
    value: "+91 9867480688",
    note: "Message us anytime on WhatsApp",
    icon: FaWhatsapp,
  },
  {
    title: "Email",
    value: "info@altusonlineschool.com",
    note: "We usually reply within 24 hours",
    icon: HiEnvelope,
  },
  {
    title: "Office",
    value: "Raheja Classic, new Link Road Oshiwara next to infinity Mall Andheri West Mumbai.",
    note: "Online support available pan-India",
    icon: HiMapPin,
  },
];

function Contact() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });
  const [submitError, setSubmitError] = useState("");

  function handleChange(field) {
    return (e) => {
      const { value } = e.target;
      setForm((prev) => ({ ...prev, [field]: value }));
      setSubmitError("");
    };
  }

  function handleSubmit(e) {
    e.preventDefault();
    const result = openContactInquiryWhatsApp(form);
    if (!result.ok) {
      setSubmitError(
        "WhatsApp number is not configured. Set REACT_APP_WHATSAPP_NUMBER in your .env file (digits with country code, e.g. 919867480644), then restart the dev server."
      );
      return;
    }
    setSubmitError("");
  }

  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${contactHeroBg})` }}
        aria-labelledby="contact-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="contact-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            Contact
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
        aria-labelledby="contact-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
              Get in touch
            </p>
            <h2
              id="contact-heading"
              className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl"
            >
              We are here to help
            </h2>
            <p className="mt-4 text-pretty text-base leading-relaxed text-ink/70 sm:mt-5 sm:text-lg">
              Have questions about admissions, academics, or counselling? Reach
              out and our team will guide you through the next steps.
            </p>
          </div>

          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {contactItems.map((item) => {
              const Icon = item.icon;
              return (
                <article
                  key={item.title}
                  className="rounded-2xl border border-brand/10 bg-white p-6 shadow-[0_16px_40px_-24px_rgba(30,22,51,0.22)] ring-1 ring-brand/5"
                >
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-light text-brand">
                    <Icon className="h-5 w-5" aria-hidden />
                  </span>
                  <h3 className="mt-4 text-lg font-semibold text-ink">{item.title}</h3>
                  <p className="mt-2 text-sm font-medium text-ink/80 sm:text-base">
                    {item.value}
                  </p>
                  {item.note ? (
                    <p className="mt-1 text-sm text-ink/60">{item.note}</p>
                  ) : null}
                </article>
              );
            })}
          </div>

          <div className="mt-10 rounded-2xl border border-brand/10 bg-brand-light/25 p-6 ring-1 ring-brand/5 sm:p-7">
            <h3 className="text-lg font-semibold text-ink">Send us a message</h3>
            <form className="mt-5 grid gap-4 sm:grid-cols-2" onSubmit={handleSubmit}>
              <label className="flex flex-col gap-1.5">
                <span className="text-sm font-medium text-ink/80">Full name</span>
                <input
                  type="text"
                  name="fullName"
                  value={form.fullName}
                  onChange={handleChange("fullName")}
                  placeholder="Enter your name"
                  required
                  className="rounded-xl border border-brand/15 bg-white px-4 py-2.5 text-sm text-ink outline-none transition focus:border-brand/35 focus:ring-2 focus:ring-brand/20"
                />
              </label>
              <label className="flex flex-col gap-1.5">
                <span className="text-sm font-medium text-ink/80">Email address</span>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange("email")}
                  placeholder="Enter your email"
                  required
                  className="rounded-xl border border-brand/15 bg-white px-4 py-2.5 text-sm text-ink outline-none transition focus:border-brand/35 focus:ring-2 focus:ring-brand/20"
                />
              </label>
              <label className="flex flex-col gap-1.5">
                <span className="text-sm font-medium text-ink/80">Mobile number</span>
                <input
                  type="tel"
                  name="mobile"
                  inputMode="tel"
                  autoComplete="tel"
                  value={form.mobile}
                  onChange={handleChange("mobile")}
                  placeholder="Enter your mobile number"
                  required
                  className="rounded-xl border border-brand/15 bg-white px-4 py-2.5 text-sm text-ink outline-none transition focus:border-brand/35 focus:ring-2 focus:ring-brand/20"
                />
              </label>
              <label className="flex flex-col gap-1.5">
                <span className="text-sm font-medium text-ink/80">Subject</span>
                <input
                  type="text"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange("subject")}
                  placeholder="What is this about?"
                  className="rounded-xl border border-brand/15 bg-white px-4 py-2.5 text-sm text-ink outline-none transition focus:border-brand/35 focus:ring-2 focus:ring-brand/20"
                />
              </label>
              <label className="flex flex-col gap-1.5 sm:col-span-2">
                <span className="text-sm font-medium text-ink/80">Message</span>
                <textarea
                  name="message"
                  rows={4}
                  value={form.message}
                  onChange={handleChange("message")}
                  placeholder="Tell us how we can help..."
                  required
                  className="rounded-xl border border-brand/15 bg-white px-4 py-3 text-sm text-ink outline-none transition focus:border-brand/35 focus:ring-2 focus:ring-brand/20"
                />
              </label>
              <div className="sm:col-span-2">
                <button
                  type="submit"
                  className="inline-flex items-center justify-center rounded-xl bg-brand px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-brand/25 transition hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
                >
                  Send on WhatsApp
                </button>
                {submitError ? (
                  <p className="mt-3 text-sm text-red-600" role="alert">
                    {submitError}
                  </p>
                ) : null}
              </div>
            </form>
          </div>

          <div className="mt-10 rounded-2xl border border-brand/10 bg-white p-3 shadow-[0_16px_40px_-24px_rgba(30,22,51,0.22)] ring-1 ring-brand/5 sm:p-4">
            <div className="flex items-center justify-between gap-3 px-2 pb-3 sm:px-3">
              <h3 className="text-lg font-semibold text-ink">Find us on map</h3>
              <span className="text-xs font-medium text-ink/60"> Andheri West, Mumbai, India</span>
            </div>
            <div className="overflow-hidden rounded-xl border border-brand/10">
              <iframe
                title="Altus Online School location map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.2434265519396!2d72.82779822515619!3d19.140818899934523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63d0713ad29%3A0xe239d9560b8b7577!2sRAHEJA%20CLASSIQUE%2C%20Phase%20D%2C%20Shastri%20Nagar%2C%20Andheri%20West%2C%20Mumbai%2C%20Maharashtra%20400053!5e0!3m2!1sen!2sin!4v1777635292323!5m2!1sen!2sin"
                className="h-72 w-full sm:h-80"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
